import { useQuery } from 'react-query';
import { DisbursementService } from '../../services/wealthlane-award-settlement-services';

const useGetDisbursementBrokerageDetails = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: any
) => {
  const {
    disbursementStatusIds,
    disbursementContainerStatusIds,
    companyIds,
    sorting,
    skipCount,
    maxResultCount,
  } = tableInfo;

  const disbursementDetails = useQuery(
    [
      'getDisbursementDetails',
      disbursementStatusIds,
      disbursementContainerStatusIds,
      companyIds,
      sorting,
      skipCount,
      maxResultCount,
    ],
    async () => {
      return await handleRequest(
        DisbursementService.getApiAwardSettlementApiAppDisbursementDisbursementDetail(
          [disbursementStatusIds],
          [disbursementContainerStatusIds],
          [companyIds],
          null,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );
  return disbursementDetails;
};

export default useGetDisbursementBrokerageDetails;
